import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/auth/AuthContext";
import { LaksmiHero, LaksmiInfo, LaksmiJoinForm, LaksmiStatusOverlay, useGuestChime } from "@/components/laksmi/LaksmiShared";

export default function LaksmiConsult() {
  const [state, setState] = useState(null);
  const [ref, setRefState] = useState(() => { try { return JSON.parse(sessionStorage.getItem("laksmi_pt_ref") || "null"); } catch (_) { return null; } });
  const setRef = (v) => { setRefState(v); if (v) sessionStorage.setItem("laksmi_pt_ref", JSON.stringify(v)); else sessionStorage.removeItem("laksmi_pt_ref"); };
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const refState = useRef(ref);
  refState.current = ref;

  const loadState = useCallback(async () => {
    try { const res = await api.get("/laksmi/state"); setState(res.data); } catch (_) {}
  }, []);

  useEffect(() => { loadState(); const t = setInterval(loadState, 15000); return () => clearInterval(t); }, [loadState]);

  useEffect(() => {
    if (!ref) return undefined;
    const poll = async () => {
      try { const res = await api.get("/laksmi/my-status", { params: ref }); setStatus(res.data); } catch (_) {}
    };
    poll();
    const t = setInterval(poll, 10000);
    return () => clearInterval(t);
  }, [ref]);

  // Overlay "selesai" auto-hides after 30 seconds.
  useEffect(() => {
    if (status?.code !== "selesai") return undefined;
    const t = setTimeout(() => { setStatus(null); setRef(null); }, 30000);
    return () => clearTimeout(t);
  }, [status?.code]);

  const { showDismiss, dismiss } = useGuestChime(status?.code);

  const join = async (fields) => {
    setBusy(true); setError("");
    try {
      const res = await api.post("/laksmi/join", { nama: fields.nama, jabatan: fields.jabatan, topik: fields.topik, nama_zoom: fields.nama_zoom });
      if (res.data.zoom_link) window.open(res.data.zoom_link, "_blank", "noopener");
      setRef({ guest_id: res.data.guest_id, token: res.data.token });
    } catch (err) { setError(err.response?.data?.detail || "Gagal join LAKSMI."); }
    finally { setBusy(false); }
  };

  if (ref && status) return <div className="laksmi-page"><LaksmiStatusOverlay status={status} showDismiss={showDismiss} onDismiss={dismiss} /></div>;

  return (
    <div className="laksmi-page" data-testid="laksmi-consult">
      <LaksmiHero>
        {state?.mode === "open"
          ? <LaksmiJoinForm isLogin submitLabel="JOIN ZOOM LAKSMI" busy={busy} error={error} onSubmit={join} />
          : <LaksmiInfo mode={state?.mode || "regular"} message={state?.message || ""} />}
      </LaksmiHero>
    </div>
  );
}
